import { render } from "./Games.vue?vue&type=template&id=5a69afe6&scoped=true"
import script from "./Games.vue?vue&type=script&lang=js"
export * from "./Games.vue?vue&type=script&lang=js"

import "./Games.vue?vue&type=style&index=0&id=5a69afe6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a69afe6"]])

export default __exports__